import React, { useEffect, useState } from "react";
import "./Category.css";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getProductCategoryByCategoryIdAPI } from "../../../../Store/Action/productCategory";
import CategoryCard from "../../CustomComponents/CategoryCard";
import CustomLoader from "../../CustomComponents/CustomLoader/CustomLoader";

const ShopByCategory = ({ data, fromBrands, brandData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [categoryData, setCategoryData] = useState([]);
  const [brandsData, setBrandData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (data) {
      // setIsLoading(true);
      setCategoryData(data);
      // setTimeout(() => setIsLoading(false), 500);
      setIsLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (fromBrands) {
      setIsLoading(true); // keep loader ON

      if (brandData && brandData.length > 0) {
        setBrandData(brandData);
        setIsLoading(false); // hide loader ONLY when data arrives
      }
    }
  }, [brandData, fromBrands]);

  const handleIndividualCategory = async (category) => {
    setIsLoading(true);
    try {
      await dispatch(
        getProductCategoryByCategoryIdAPI(
          category?.product_category_id,
          (result) => {
            const fetchedData = result?.data[0];
            const subCategories = fetchedData?.product_sub_categories || [];

            if (subCategories.length > 0) {
              navigate("/sub-categories", {
                state: { subCategories, fromHomePageCategory:true },
              });
            } else {
              navigate(`/productsList/${category?.product_category_id}`, {
                state: {
                  subCategoryId: fetchedData?.product_category_id,
                  subCategoryName: fetchedData?.product_category_name,
                },
              });
            }
          }
        )
      );
    } catch (error) {
      console.log("Error fetching subcategories:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleIndividualBrand = (brand) => {
    navigate("/categories-by-brand", {
      state: { fromBrands: true, brand },
    });
  };

  const handleViewAllClickFunc = () => {
    navigate(fromBrands ? "brands-listing" : "/shop-by-category", {
      state: fromBrands ? { fromBrands: true } : { fromShopByCategory: true },
    });
  };
  return (
    <div className="shopByCategoryDiv">
      <div className="upperContent">
        <h1>{fromBrands ? "Our Brands" : "Shop by Category"}</h1>
        <p>
          {fromBrands
            ? "Browse Brands to find the perfect product, tailored for you"
            : "Browse categories to find the perfect product, tailored for you"}
        </p>
      </div>
      <div className="lowerContent">
        <div className="hrLine" />
        {!fromBrands && (
          <>
            <div className="view-all">
              <p onClick={handleViewAllClickFunc}>View all</p>
            </div>
          </>
        )}
        {/* <div className="cardsContainer"> */}
        {isLoading ? (
          <div className="loaderContainer">
            <CustomLoader />
          </div>
        ) : fromBrands ? (
          brandData?.length > 0 ? (
            <>
              <div className="cardsContainer">
                {brandsData.map((brand, index) => (
                  <CategoryCard
                    key={index}
                    item={{
                      image: brand?.brand_image_url || "",
                      name: brand.user_shop_name,
                    }}
                    onClick={() => handleIndividualBrand(brand)}
                  />
                ))}
              </div>
            </>
          ) : (
            <p className="no-data-text">No brands available</p>
          )
        ) : categoryData?.length > 0 ? (
          <>
            <div className="cardsContainer">
              {categoryData.map((category, index) => (
                <CategoryCard
                  key={index}
                  item={{
                    image: category?.product_category_storage_url,
                    name: category.product_category_name,
                  }}
                  onClick={() => handleIndividualCategory(category)}
                />
              ))}
            </div>
          </>
        ) : (
          <p className="no-data-text">No categories available</p>
        )}
        {/* </div> */}
      </div>
    </div>
  );
};

export default ShopByCategory;
